import moment from "moment";

export const isDateToday: (dateAsString: string) => boolean = (dateAsString) => moment(dateAsString).startOf('day').isSame(moment(), 'day');
